<template>
    <v-dialog v-model="showFlag" width="900" scrollable>
      <v-card>
        <DialogHeader :title="$t('dialog.selectComponent.title')" :subtitle="$t('dialog.selectComponent.subtitle')" icon="mdi-swap-horizontal"></DialogHeader>

        <v-card-text style="height: 350px;">
          <v-list dense>
       
                  <v-list-item  v-for="item in components" :key="item.uuid">
                    <v-img style="cursor:pointer" @click="onItemSelected(item.uuid)" max-height="100" class="mt-4 mb-4 mr-6" max-width="100" contain :src="item.imageSrc"></v-img>
                    <v-list-item-content>
                        <v-list-item-title style="cursor:pointer" @click="onItemSelected(item.uuid)"  v-html="item.longname"></v-list-item-title>
                        <v-list-item-subtitle>{{$t("dialog.addComponent.lastKnownPrice")}}: {{lastKnownPrice(item)}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
               
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="isLoggedIn" color="primary" outlined @click="suggestComponent">
            <v-icon>mdi-lightbulb-on-outline</v-icon>
            {{$t("dialog.addComponent.suggestComponent")}}
          </v-btn>
          <v-btn color="primary" @click="onCloseButtonClick">{{ $t('dialog.common.close') }}</v-btn>
        </v-card-actions>

      </v-card>

      <!-- Suggest Component Dialog -->
      <SuggestComponentDialog ref="suggestDialog" />
      
      <!-- JSON Dialog for showing complete file -->
      <JSONDialog ref="jsonDialog" />
    </v-dialog>
</template>

<script>
import DialogHeader from "@/components/DialogHeader.vue"
import SuggestComponentDialog from "@/dialogs/SuggestComponentDialog.vue"
import JSONDialog from "@/dialogs/JSONDialog.vue"
import { toFixed } from "@/utils/Wire.js"

export default {
  name: "SelectComponentDialog",
  data() {
    return {
      showFlag: false,
      resolve: null,
      type: null
    }
  },
  components: {
    DialogHeader,
    SuggestComponentDialog,
    JSONDialog
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn']
    },
    components() {
      if ( this.type === null ) {
        return []  
      }
      return this.$store.state[this.type].components.filter( element => element.uuid !== "custom" )
    }
  },
  methods: {
    async show( type) {
      this.type = type
      return new Promise((resolve) => {
        this.resolve = resolve
        this.showFlag = true
      })
    },
    lastKnownPrice ( item ) {
      if (item.shopping.length === 0) {
        return "-"
      }
      const low = item.shopping.reduce((prev, curr) => prev.lastKnownPrice < curr.lastKnownPrice ? prev : curr)
      const high = item.shopping.reduce((prev, curr) => prev.lastKnownPrice > curr.lastKnownPrice ? prev : curr)
      if (low.lastKnownPrice === high.lastKnownPrice ) {
        return toFixed(low.lastKnownPrice) + " €"
      }
      return toFixed(low.lastKnownPrice) + " - " + toFixed(high.lastKnownPrice) + " €"
    },
    onItemSelected(uuid) {
      this.showFlag = false
      this.resolve && this.resolve(uuid)
    },
    onCloseButtonClick() {
      this.showFlag = false
      this.resolve && this.resolve()
    },
    async suggestComponent() {
      // Open the new suggest component dialog
      const result = await this.$refs.suggestDialog.show(this.type)
      
      if (result) {
        // Show the complete file content in JSONDialog
        await this.$refs.jsonDialog.show(result.completeFileContent)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/assets/colors.less';

::v-deep .v-card {
  border: @dialog-border-style !important;
  border-radius: @dialog-corner-radius !important;
  box-sizing: border-box !important;
}
</style>
